<template>
  <div class="protocol-list-container">
    <!-- 协议列表页面 -->
    <div v-if="showList" class="list-page">
      <div class="header">
        <van-icon name="arrow-left" class="back-btn" @click="handleBack" />
        <h1 class="title">协议列表</h1>
      </div>

      <!-- 加载状态 -->
      <van-loading v-if="loading" class="loading" type="spinner" color="#1989fa" />

      <!-- 接口协议按返回内容展示，列表末尾保留个人信息共享授权协议的固定入口。 -->
      <div v-else class="protocol-items">
        <van-cell
          v-for="(item, index) in protocolData"
          :key="index"
          :title="item.name"
          is-link
          @click="handleProtocolClick(item)"
          class="protocol-item"
        />
        <van-cell
          title="个人信息共享授权协议"
          is-link
          @click="handleSharedProtocolClick"
          class="protocol-item"
        />
      </div>
    </div>

    <!-- 协议详情页面 -->
    <div v-else class="detail-page">
      <div class="header">
        <van-icon name="arrow-left" class="back-btn" @click="showList = true" />
        <h1 class="title">{{ currentProtocol.name }}</h1>
      </div>
      <div class="protocol-content" v-html="currentProtocol.content"></div>
    </div>
  </div>
</template>

<script>
import { Cell, Icon, Loading } from 'vant'
import * as API_Common from '@/api/common.js'

export default {
  name: 'ProtocolList',
  components: {
    'van-cell': Cell,
    'van-icon': Icon,
    'van-loading': Loading,
  },
  data() {
    return {
      showList: true,
      loading: false,
      protocolData: [], // 存储API返回的协议数据
      currentProtocol: {
        name: '',
        content: '',
        url: '',
      },
      channelCode: null, // 从路由参数中获取
    }
  },
  mounted() {
    // 路由中的渠道号用于查询该半流程渠道实际配置的协议列表。
    this.channelCode = this.$route.params.channelCode || 1
    console.log('channelCode:', this.channelCode)
    this.getProtocolData()
  },
  methods: {
    handleBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },

    // 获取协议数据
    getProtocolData() {
      this.loading = true
      API_Common.getHalfChannelProductList(this.channelCode)
        .then((data) => {
          this.loading = false
          console.log('接口返回数据:', data)
          if (data && data.code === 200) {
            // getProtocolList 已直接返回 name/url 数组，不再解析旧产品分组结构。
            this.protocolData = Array.isArray(data.data) ? data.data : []
          } else {
            this.protocolData = []
            this.$toast((data && data.msg) || '获取协议数据失败')
          }
        })
        .catch((err) => {
          this.loading = false
          this.protocolData = []
          this.$toast('网络错误，请稍后重试')
          console.error('获取协议数据失败:', err)
        })
    },

    // 处理协议点击 - 直接跳转到协议URL
    handleProtocolClick(contract) {
      if (contract.url) {
        console.log('跳转协议URL:', contract.url)
        window.location.href = contract.url
      } else {
        this.$toast('协议链接不存在')
      }
    },

    handleSharedProtocolClick() {
      // 授权书沿用当前站点的接口配置，只携带查询合作方所需的渠道号。
      window.location.href = `/grxxsqs.html?channelNo=${encodeURIComponent(this.channelCode || '')}`
    },
  },
}
</script>

<style lang="scss" scoped>
.protocol-list-container {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;

  .header {
    display: flex;
    align-items: center;
    padding: 0.3rem 0.36rem;
    background-color: #fff;
    border-bottom: 1px solid #eee;

    .back-btn {
      font-size: 0.4rem;
      color: #333;
    }

    .title {
      flex: 1;
      text-align: center;
      font-size: 0.36rem;
      font-weight: 600;
      margin: 0;
      color: #333;
    }
  }

  .list-page {
    flex: 1;
    display: flex;
    flex-direction: column;

    .loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 2rem;
      margin: 1rem 0;
    }

    .empty-state {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 3rem;
      margin-top: 2rem;
    }

    .protocol-items {
      background-color: #fff;

      .protocol-item {
        background-color: #fff;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }
      }
    }
  }

  .detail-page {
    flex: 1;
    display: flex;
    flex-direction: column;

    .protocol-content {
      flex: 1;
      padding: 0.3rem 0.36rem;
      overflow-y: auto;
      font-size: 0.28rem;
      line-height: 0.48rem;
      color: #333;
      text-align: justify;

      h2 {
        font-size: 0.32rem;
        font-weight: 600;
        margin: 0 0 0.3rem 0;
        text-align: center;
      }

      p {
        margin: 0 0 0.2rem 0;
      }
    }
  }
}
</style>
